export const PROCESSING_GIF_ALT = "processing gif";
